var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#83ACEB",
    fillRule: "evenodd",
    d: "M4.9 7.464a1.934 1.934 0 1 1 3.868 0 1.934 1.934 0 0 1-3.868 0m1.934 3.868h.001a2.9 2.9 0 0 1 2.868 2.47 3.87 3.87 0 0 0-1.902 3.33v1.934H3.934v-4.834a2.9 2.9 0 0 1 2.9-2.9M2.967 21H22v-6.767a4.83 4.83 0 0 0-2.127-4.007 3.867 3.867 0 1 0-6.57-2.56 3.4 3.4 0 0 0-1.151-.202c-.525 0-1.021.12-1.465.333q.014-.164.014-.333a3.867 3.867 0 1 0-6.574 2.762A4.83 4.83 0 0 0 2 14.233V21zm12.376-9.024a2.9 2.9 0 0 1 4.723 2.256v4.834h-3.564v-1.933c0-1.53-.889-2.854-2.179-3.48q.028-.136.068-.268c.427-.377.758-.86.952-1.41m-5.608 5.157c0-1.068.865-1.934 1.933-1.934h.967c1.068 0 1.934.866 1.934 1.934v1.933H9.735zm7.43-11.602a1.934 1.934 0 1 1 0 3.867 1.934 1.934 0 0 1 0-3.867m-6.464 5.317a1.45 1.45 0 1 1 2.9 0 1.45 1.45 0 0 1-2.9 0",
    clipRule: "evenodd"
  })));
};
export default SvgGroup;